export const HR = <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#F6F8FD"/>
    <g clipPath="url(#clip0_1108_11918)">
        <rect x="9" y="12" width="22" height="16" rx="2" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 23H31V28H9V23Z" fill="#1A47B8"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 12H31V17H9V12Z" fill="#F93939"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M17.3809 16.2669H18.4285V17.3335H17.3809V16.2669ZM19.4761 15.2002H20.5237V17.3335H19.4761V15.2002ZM21.5713 16.2669H22.619V17.3335H21.5713V16.2669Z"
              fill="#3A99FF"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M20.523 15.2002H21.5706V17.3335H20.523V15.2002ZM18.4277 15.2002H19.4754V17.3335H18.4277V15.2002Z"
              fill="#1A47B8"/>
        <mask id="mask0_1108_11918" maskUnits="userSpaceOnUse" x="17" y="17" width="6"
              height="7">
            <path
                d="M22.619 21.0668C22.619 22.5388 21.4456 23.7335 19.9999 23.7335C18.5542 23.7335 17.3809 22.5388 17.3809 21.0668V17.3335H22.619V21.0668Z"
                fill="white"/>
        </mask>
        <g mask="url(#mask0_1108_11918)">
            <path
                d="M22.619 21.0668C22.619 22.5388 21.4456 23.7335 19.9999 23.7335C18.5542 23.7335 17.3809 22.5388 17.3809 21.0668V17.3335H22.619V21.0668Z"
                fill="#F93939"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M18.4285 22.6668H19.4761V23.7335H18.4285V22.6668ZM20.5237 22.6668H21.5713V23.7335H20.5237V22.6668ZM19.4761 21.6002H20.5237V22.6668H19.4761V21.6002ZM18.4285 20.5335H19.4761V21.6002H18.4285V20.5335ZM20.5237 20.5335H21.5713V21.6002H20.5237V20.5335ZM19.4761 19.4668H20.5237V20.5335H19.4761V19.4668ZM18.4285 18.4002H19.4761V19.4668H18.4285V18.4002ZM20.5237 18.4002H21.5713V19.4668H20.5237V18.4002ZM19.4761 17.3335H20.5237V18.4002H19.4761V17.3335ZM21.5713 17.3335H22.619V18.4002H21.5713V17.3335ZM21.5713 19.4668H22.619V20.5335H21.5713V19.4668ZM21.5713 21.6002H22.619V22.6668H21.5713V21.6002ZM17.3809 21.6002H18.4285V22.6668H17.3809V21.6002ZM17.3809 19.4668H18.4285V20.5335H17.3809V19.4668ZM17.3809 17.3335H18.4285V18.4002H17.3809V17.3335Z"
                  fill="white"/>
        </g>
    </g>
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#DFE1EB"/>
    <defs>
        <clipPath id="clip0_1108_11918">
            <rect x="9" y="12" width="22" height="16" rx="2" fill="white"/>
        </clipPath>
    </defs>
</svg>

export const EE = <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#F6F8FD"/>
    <g clipPath="url(#clip0_1108_11902)">
        <path d="M28.9048 12H11.0952C9.93807 12 9 12.9551 9 14.1333V25.8667C9 27.0449 9.93807 28 11.0952 28H28.9048C30.0619 28 31 27.0449 31 25.8667V14.1333C31 12.9551 30.0619 12 28.9048 12Z" fill="#151515"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 23H31V28H9V23Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 12H31V17H9V12Z" fill="#3A99FF"/>
    </g>
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#DFE1EB"/>
    <defs>
        <clipPath id="clip0_1108_11902">
            <rect x="9" y="12" width="22" height="16" rx="2" fill="white"/>
        </clipPath>
    </defs>
</svg>

export const GR = <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#F6F8FD"/>
    <rect x="9" y="12" width="22" height="16" rx="2" fill="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M9 12H13.1905V16.2667H9V12ZM15.2857 12H19.4762V16.2667H15.2857V12ZM9 18.4H13.1905V22.6667H9V18.4ZM15.2857 18.4H19.4762V22.6667H15.2857V18.4ZM19.4762 12H31V14.1333H19.4762V12ZM19.4762 16.2667H31V18.4H19.4762V16.2667Z" fill="#1A47B8"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M9 20.5332H31V22.6665H9V20.5332ZM13.1905 20.5332H15.2857V22.6665H13.1905V20.5332ZM9 24.7999H31V26.9332H9V24.7999Z" fill="#1A47B8"/>
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#DFE1EB"/>
</svg>

export const IT = <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#F6F8FD"/>
    <g clipPath="url(#clip0_1108_11938)">
        <rect x="9" y="12" width="22" height="16" rx="2" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 12H16V28H9V12Z" fill="#249F58"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M24 12H31V28H24V12Z" fill="#F93939"/>
    </g>
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#DFE1EB"/>
    <defs>
        <clipPath id="clip0_1108_11938">
            <rect x="9" y="12" width="22" height="16" rx="2" fill="white"/>
        </clipPath>
    </defs>
</svg>

export const NL = <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#F6F8FD"/>
    <g clipPath="url(#clip0_1108_11797)">
        <rect x="9" y="12" width="22" height="16" rx="2" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 23H31V28H9V23Z" fill="#1E448D"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 12H31V17H9V12Z" fill="#B01923"/>
    </g>
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#DFE1EB"/>
    <defs>
        <clipPath id="clip0_1108_11797">
            <rect x="9" y="12" width="22" height="16" rx="2" fill="white"/>
        </clipPath>
    </defs>
</svg>

export const RU = <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#F6F8FD"/>
    <g clipPath="url(#clip0_1108_11893)">
        <rect x="9" y="12" width="22" height="16" rx="2" fill="#1A47B8"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 22.6665H31V27.9998H9V22.6665Z" fill="#F93939"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 12H31V17.3333H9V12Z" fill="white"/>
    </g>
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#DFE1EB"/>
    <defs>
        <clipPath id="clip0_1108_11893">
            <rect x="9" y="12" width="22" height="16" rx="2" fill="white"/>
        </clipPath>
    </defs>
</svg>

